import { create } from 'zustand';

export const useVeilStore = create((set) => ({
  isVisible: false,
  showVeil: () => set({ isVisible: true }),
  hideVeil: () => set({ isVisible: false }),
  toggleVeil: () => set((state) => ({ isVisible: !state.isVisible })),
}));